import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class ShareDataService {

  private data = {};

  public setSharedDataByKey(key: string, value: any): void {
    this.data[key] = value;
  }

  public setSharedData(data: any): void {
    this.data = data;
  }

  public getSharedDateByKey(key: string): any {
    const me = this;
    return me.data[key];
  }

  public getSharedData(): any {
    const me = this;
    return me.data;
  }

  public resetSharedData(): void {
    const me = this;
    me.data = {};
  }
}
